import { useMutation, useQueryClient } from '@tanstack/react-query';
import { handleUserMutationError } from '@/features/users/services/userErrorHandler';
import { reactivateDealer } from '../services/dealers';
import { dealerKeys } from './useDealersQuery';
import type { Dealer } from '../types/dealers.types';

export const useReactivateDealerMutation = () => {
    const queryClient = useQueryClient();

    return useMutation<Dealer, Error, string>({
        mutationFn: (id) => reactivateDealer(id),
        onSuccess: (_, id) => {
            queryClient.invalidateQueries({ queryKey: dealerKeys.detail(id) });
            queryClient.invalidateQueries({ queryKey: dealerKeys.lists() });
        },
        onError: (error) => handleUserMutationError(error),
    });
};
